module.exports = __webpack_public_path__ + "static/media/circle-graphs-icon.73226110.svg";